import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "heatmap-wrapper" }
const _hoisted_2 = { class: "heatmap-header" }
const _hoisted_3 = { class: "heatmap-title" }
const _hoisted_4 = { class: "heatmap-options" }
const _hoisted_5 = { class: "heatmap-chart" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_chart = _resolveComponent("v-chart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('generalSatisfaction')), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("p", {
        class: _normalizeClass({ active: _ctx.type === 'satisfaction' }),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.chooseOption('satisfaction')))
      }, _toDisplayString(_ctx.$t('customersSatisfaction')), 3),
      _createElementVNode("p", {
        class: _normalizeClass({ active: _ctx.type === 'amoun' }),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.chooseOption('amoun')))
      }, _toDisplayString(_ctx.$t('customersAmount')), 3)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_v_chart, {
        class: "chart",
        option: _ctx.chartOption,
        autoresize: ""
      }, null, 8, ["option"])
    ])
  ]))
}